































import { Component, Inject, Model, Prop, Vue, Watch, Provide } from "vue-property-decorator";
import Box3D from '../components/Box3D.vue';
import FileSelector from '../components/FileSelector.vue';
import UserData from '../vo/UserData';
import Reticle from '../components/Reticle.vue';
import ChatView from '../components/ChatView.vue';
import FormView from '../components/FormView.vue';
import Config from '../utils/Config';
import Persona from './Persona.vue';
import SockController, { SOCK_ACTIONS } from '../controller/SockController';
import Api from '../utils/Api';
import SocketEvent from '../vo/SocketEvent';
import gsap from 'gsap';
import { MESSAGE_TYPE } from '../vo/ChatMessageData';
import RoomData from '../vo/RoomData';

@Component({
	components:{
		Persona,
		Box3D,
		Reticle,
		ChatView,
		FileSelector,
	}
})
export default class Game extends Vue {

	public playerReady:boolean = false;
	public forcePersona:boolean = false;
	public playerIndex:number = 0;
	public showGame:boolean = false;
	public reticleTarget:{x:number, y:number} = {x:0, y:0};
	public faceIndex:number = 0;
	public readyStateDelay:number = 0;

	public ELEMENTS:string[] = Config.ELEMENTS;

	public get ready():boolean {
		return this.$store.state.room.users.length == 3;
	}

	public get users():UserData[] {
		let users:UserData[] = this.$store.state.room.users.concat();
		users.sort((a,b)=> {
			if(a.index < b.index) return -1;
			if(a.index > b.index) return 1;
			return 0;
		})
		return users;
	}

	public mounted():void {
		this.playerIndex = (<UserData>this.$store.state.me).index;
	}

	public beforeDestroy():void {
	}

	public onPersonaComplete():void {
		this.forcePersona = false;
		if(this.showGame) {
			gsap.to(this.$refs.content, {opacity:1, duration:.5});
		}else{
			this.showGame = true;
		}
	}

	public setReticlePos(pos:DOMRect):void {
		// console.log("Reticle pos : ", pos.x, pos.y);
		let topLeft = {x:0, y:0};
		topLeft.x = ((document.body.clientWidth-400) - Config.BOX_WIDTH) *.5
		topLeft.y = (document.body.clientHeight - Config.BOX_HEIGHT) *.5
		this.reticleTarget.x = pos.x - topLeft.x;
		this.reticleTarget.y = pos.y - topLeft.y;
		this.checkComplete();
	}

	public updateCubeFace(faceIndex:number):void {
		// console.log("Cube Face "+faceIndex)
		this.faceIndex = faceIndex;
		this.checkComplete();
	}

	private checkComplete():void {
		if(!this.reticleTarget) return;
		let step = Config.STEPS[this.$store.state.room.currentStepIndex];
		for (let i = 0; i < step.elements.length; i++) {
			const element = step.elements[i];
			if(step.elements[i] == Config.ELEMENTS[this.playerIndex]) {
				// console.log("My goal is index ", i)
				// console.log(step.angles[i]);
				// console.log(step.targets[i]);
				// console.log(step.faceIndex[i]);
				let retiCleDist = Math.sqrt(Math.pow(this.reticleTarget.x - step.targets[i].x,2) + Math.pow(this.reticleTarget.y - step.targets[i].y,2))
				let isReady = false;
				if(retiCleDist < 15 && this.faceIndex == step.faceIndex[i]) {
					//Reticle targeting appropriate place and cube properly oriented
					isReady = true;
				}
				this.sendReadyState(isReady)
			}
		}
	}

	private async sendReadyState(isReady:boolean, force:boolean = false):Promise<void> {
		clearTimeout(this.readyStateDelay);
		if(isReady && !force) {
			//Wait a second before sending a ready state so it's not too easy to find the right
			//reticle's spot by just dragging it all over the box
			this.readyStateDelay = setTimeout(_=> this.sendReadyState(isReady, true), 1000);
			return;
		}
		
		if(this.playerReady == isReady) return;//State didn't change, ignore it

		this.playerReady = isReady;

		try {
			let res = await Api.post("user/ready", {state:isReady, uid:this.$store.state.me.id, room:this.$store.state.room.name});
			if(res.success) {
				//all good
				if(res.goNextStep) {
					let stepIndex = (<RoomData>this.$store.state.room).currentStepIndex + 1;
					let data = {
						type:MESSAGE_TYPE.SPLITTER,
						from:this.$store.state.me.id,
						stepIndex
					}
					SockController.instance.sendMessage({action:SOCK_ACTIONS.SEND_MESSAGE, includeSelf:true, data});
				}
			}else{
				this.$store.state.alert = "Unable to update your current state :(<br />"+res.message;
			}
		}catch(error) {
			this.$store.state.alert = "Unable to update your current state :(";
		}
	}
	
	@Watch("$store.state.room.currentStepIndex")
	public onNextStep(e:SocketEvent):void {
		this.forcePersona = true;
		gsap.to(this.$refs.content, {opacity:0, duration:.5});
	}

}
